// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__17SjI","icon":"SortAdornment_icon__aKV9y","up":"SortAdornment_up__29yUI","down":"SortAdornment_down__gvsmv","active":"SortAdornment_active__3XVa3"};